import { parseValorMonetarioBr } from './validacaoDespesaFornecedor'

/** ID do status Reservado (reservas_status.tip_id / reservas.res_idstatus). */
export const STATUS_RESERVADO_ID = 1

export const MENSAGEM_RESERVA_STATUS_RESERVADO =
  'Há reserva(s) ainda com status Reservado. Avise o setor de Reservas para atualizar o status e, depois disso, pesquise novamente para concluir o acerto.'

/** Estilo do alerta amarelo usado no cadastro/edição do acerto. */
export const estiloAlertAcertoWarning = {
  backgroundColor: '#fff3cd',
  border: '1px solid #ffc107',
  borderRadius: '6px',
  color: '#664d03',
  padding: '10px 14px',
  margin: 0,
  lineHeight: 1.4,
}

export function reservaStatusReservado(reserva) {
  const statusId = Number(reserva?.status?.tip_id ?? reserva?.res_idstatus ?? 0)
  return statusId === STATUS_RESERVADO_ID
}

export function existeReservaStatusReservado(reservas = []) {
  return (reservas || []).some(reservaStatusReservado)
}

function round2(value) {
  return Math.round((Number(value) + Number.EPSILON) * 100) / 100
}

/**
 * Parte de grupo cujo valor (passeio + taxa do cais) outro guia já recebeu
 * no embarque. Vem do backend em `recebido_no_grupo`.
 */
export function getRecebidoNoGrupo(reserva) {
  const grupo = reserva?.recebido_no_grupo
  const valor = round2(Number(grupo?.valor) || 0)
  if (valor <= 0) return null
  return {
    valor,
    taxas: round2(Number(grupo?.taxas) || 0),
    guias: grupo?.guias || ''
  }
}

/**
 * O que este guia ainda precisa receber no acerto. A taxa do cais não entra
 * no "a receber" do acerto, mas faz parte do que o outro guia cobrou deste
 * carro — por isso o abatimento só alcança o passeio depois de cobrir a taxa.
 */
export function aReceberNoAcerto(reserva) {
  const base = round2(parseValorMonetarioBr(reserva?.valor_total_embarque ?? 0))
  const grupo = getRecebidoNoGrupo(reserva)
  if (!grupo) return base
  return round2(Math.max(0, Math.min(base, base + grupo.taxas - grupo.valor)))
}

export function getTotalAReceberEsperado(reserva) {
  return round2(
    parseValorMonetarioBr(reserva?.total_a_receber ?? reserva?.valor_total_embarque ?? 0)
  )
}

function hasPagamentoInformado(pagamento) {
  const formaPagamentoValue = pagamento?.formaPagamento?.value
  const valorNumerico = parseValorMonetarioBr(pagamento?.valor ?? 0)
  return Boolean(formaPagamentoValue && Number(formaPagamentoValue) > 0 && valorNumerico > 0)
}

function valorPagamentoComTaxa(pagamento) {
  const valor = parseValorMonetarioBr(pagamento?.valor ?? 0)
  if (valor <= 0) return 0
  if (pagamento?.formaPagamento?.pag_credito !== 'SIM') return valor
  const parcela = Number(pagamento?.parcela?.value ?? 1)
  const taxa = parcela <= 1 ? 0.05 : 0.15
  return valor + valor * taxa
}

/** Soma pagamentos no embarque (com taxa de cartão) informados no acerto. */
export function getTotalPagoInformadoReserva(reserva) {
  const pagamentosEmbarque = reserva?.pagamentosEmbarque || []
  return round2(
    pagamentosEmbarque.reduce((acumulado, pagamento) => {
      if (!hasPagamentoInformado(pagamento)) return acumulado
      return acumulado + valorPagamentoComTaxa(pagamento)
    }, 0)
  )
}

export function getReservaPagamentoStatus(reserva) {
  const totalEsperado = getTotalAReceberEsperado(reserva)
  const totalPago = getTotalPagoInformadoReserva(reserva)

  if (totalEsperado <= 0) return 'pagamento-ok'
  if (totalPago <= 0) return 'sem-pagamento'
  if (totalPago + 0.009 < totalEsperado) return 'pagamento-parcial'
  return 'pagamento-ok'
}

export function reservaPagamentoCompleto(reserva) {
  if (reservaStatusReservado(reserva)) return true
  return getReservaPagamentoStatus(reserva) === 'pagamento-ok'
}
